module.exports = __webpack_public_path__ + "img/Haefele_menu12.7e6d43ef.png";